/* ============================================================
   MERCH MASTER \u2014 global.js
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents, currency) {
    var n = (cents || 0) / 100;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(n); }
    catch (e) { return '$' + n.toFixed(2); }
  }
  function refreshCartCount() {
    if (!window.fetch) return Promise.resolve(null);
    return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count; el.style.display = c.item_count > 0 ? '' : 'none';
        });
        return c;
      }).catch(function () { return null; });
  }
  /* Mobile nav */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (!t) return;
    var nav = document.querySelector('[data-mobile-nav]');
    if (nav) { nav.classList.toggle('is-open'); t.setAttribute('aria-expanded', nav.classList.contains('is-open')); }
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var w = btn.closest('[data-qty]'); if (!w) return;
    var input = w.querySelector('input'); if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var val = parseInt(input.value, 10) || 0;
    input.value = Math.max(parseInt(input.min || '0', 10), val + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* View toggle */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-view]'); if (!btn) return;
    var grid = document.querySelector('[data-product-grid]'); if (!grid) return;
    grid.classList.toggle('product-grid--list', btn.getAttribute('data-view') === 'list');
    document.querySelectorAll('[data-view]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
  });

  /* Filter auto-submit */
  document.addEventListener('change', function (e) { if (e.target.closest('[data-auto-submit]')) { var f = e.target.closest('[data-filter-form]'); if (f) f.submit(); } });
  document.addEventListener('blur', function (e) { if (e.target.matches && e.target.matches('[data-auto-submit-blur]')) { var f = e.target.closest('[data-filter-form]'); if (f) f.submit(); } }, true);

  /* Gallery thumbnails */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]'); if (!thumb) return;
    var g = thumb.closest('[data-gallery]'); if (!g) return;
    var main = g.querySelector('[data-gallery-main] img'); var src = thumb.getAttribute('data-full');
    if (main && src) { main.src = src; main.removeAttribute('srcset'); }
    g.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); }); thumb.classList.add('is-active');
  });

  /* Variant -> image/price */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-variant-select]'); if (!sel) return;
    var opt = sel.options[sel.selectedIndex]; if (!opt) return;
    var root = sel.closest('.product') || document;
    var img = root.querySelector('[data-gallery-main] img'); var src = opt.getAttribute('data-image');
    if (img && src) { img.src = src; img.removeAttribute('srcset'); root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-full') === src); }); }
    var pe = root.querySelector('[data-product-price]'); var price = opt.getAttribute('data-price'); if (pe && price) pe.textContent = price;
    var note = root.querySelector('[data-stock-note]');
    if (note) {
      var left = parseInt(opt.getAttribute('data-stock'), 10);
      if (left > 0) { note.querySelector('[data-stock-text]').textContent = (note.getAttribute('data-template') || 'Only [count] left in stock').replace('[count]', left); note.hidden = false; }
      else { note.hidden = true; }
    }
    updateOrderTotal(sel.closest('.product__form') || root);
  });

  /* Live order total for custom (per-case) products so buyers don't do mental math */
  function updateOrderTotal(root) {
    root = root || document;
    var el = root.querySelector('[data-order-total]'); if (!el) return;
    var amt = el.querySelector('[data-order-total-amount]');
    var lab = el.querySelector('[data-unit-price-label]');
    var qtyInput = root.querySelector('[data-qty] input[name="quantity"]') || root.querySelector('input[name="quantity"]');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 0) : 0;
    var cur = el.getAttribute('data-currency') || 'USD';
    var cents = NaN, pm = null;
    var sel = root.querySelector('[data-variant-select]');
    if (sel && sel.options[sel.selectedIndex]) {
      cents = parseInt(sel.options[sel.selectedIndex].getAttribute('data-price-cents'), 10);
      pm = sel.options[sel.selectedIndex].getAttribute('data-price');
    }
    if (isNaN(cents)) cents = parseInt(el.getAttribute('data-unit-cents'), 10);
    if (isNaN(cents)) { el.style.display = 'none'; return; }
    el.style.display = '';
    if (lab && pm) lab.textContent = pm + ' per case';
    if (amt) amt.textContent = money(cents * Math.max(0, qty), cur);
  }
  document.addEventListener('input', function (e) {
    var q = e.target.closest && e.target.closest('input[name="quantity"]'); if (!q) return;
    updateOrderTotal(q.closest('.product__form') || document);
  });
  document.addEventListener('change', function (e) {
    var q = e.target.closest && e.target.closest('input[name="quantity"]'); if (!q) return;
    updateOrderTotal(q.closest('.product__form') || document);
  });
  document.querySelectorAll('.product__form').forEach(function (f) {
    if (f.querySelector('[data-order-total]')) updateOrderTotal(f);
  });

  /* Carousel arrows */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-car-prev]'); var next = e.target.closest('[data-car-next]');
    if (!prev && !next) return;
    var car = (prev || next).closest('.product__carousel'); var track = car && car.querySelector('[data-thumb-track]');
    if (!track) return;
    var delta = Math.max(track.clientWidth * 0.7, 120);
    track.scrollBy({ left: prev ? -delta : delta, behavior: 'smooth' });
  });

  /* Cup product carousel arrows */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-cup-prev]'); var next = e.target.closest('[data-cup-next]');
    if (!prev && !next) return;
    var car = (prev || next).closest('[data-cup-carousel]'); var track = car && car.querySelector('[data-cup-track]');
    if (!track) return;
    var delta = Math.max(track.clientWidth * 0.8, 220);
    track.scrollBy({ left: prev ? -delta : delta, behavior: 'smooth' });
  });

  /* Custom cups slideshow (arrows, dots, swipe, keyboard, optional auto-rotate) */
  function initSlideshow(root) {
    if (!root || root.__mmSlides) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slide-dot]'));
    var delay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    var cur = 0, timer = null, held = false;
    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === cur;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        var a = s.querySelector('a'); if (a) a.tabIndex = on ? 0 : -1;
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === cur);
        if (k === cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (delay > 0 && !reduce && !held) timer = setInterval(function () { if (!document.hidden) go(cur + 1); }, delay); }
    function hold(on) { held = on; if (on) stop(); else start(); }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-slide-prev]')) { go(cur - 1); start(); return; }
      if (e.target.closest('[data-slide-next]')) { go(cur + 1); start(); return; }
      var d = e.target.closest('[data-slide-dot]');
      if (d) { go(parseInt(d.getAttribute('data-slide-dot'), 10) || 0); start(); }
    });
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold(true); });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hold(false); });
    root.addEventListener('focusin', function () { hold(true); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) hold(false); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    });
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = y0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(cur + (dx < 0 ? 1 : -1));
      start();
    }, { passive: true });
    root.__mmSlides = { go: go, hold: hold, index: function (el) { return slides.indexOf(el); } };
    start();
  }
  document.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
  /* Theme editor: re-init on section reload; jump to a slide when it's selected in the sidebar */
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-slideshow]').forEach(initSlideshow); });
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest && e.target.closest('[data-slide]'); if (!s) return;
    var root = s.closest('[data-slideshow]'); if (!root || !root.__mmSlides) return;
    root.__mmSlides.go(root.__mmSlides.index(s)); root.__mmSlides.hold(true);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var s = e.target.closest && e.target.closest('[data-slide]'); if (!s) return;
    var root = s.closest('[data-slideshow]'); if (root && root.__mmSlides) root.__mmSlides.hold(false);
  });

  /* Add to cart without leaving the page (product form with data-after-add="stay") */
  var added, addedTimer;
  function closeAdded() { if (added) { added.classList.remove('is-open'); clearTimeout(addedTimer); } }
  function showAdded(info, count) {
    if (!added) {
      added = document.createElement('div'); added.className = 'added'; added.setAttribute('role', 'status'); added.setAttribute('aria-live', 'polite');
      added.innerHTML = '<div class="added__head"><span class="added__check" aria-hidden="true">\u2713</span><b>Added to cart</b><button type="button" class="added__x" data-added-close aria-label="Close">\u00d7</button></div>' +
        '<div class="added__item"><span class="added__img" data-added-img></span><div><b data-added-title></b><span data-added-meta></span></div></div>' +
        '<div class="added__actions"><a class="btn btn--full" data-added-cart href="' + rootUrl() + 'cart">View cart</a><button type="button" class="btn btn--outline btn--full" data-added-close>Keep shopping</button></div>';
      added.addEventListener('click', function (e) { if (e.target.closest('[data-added-close]')) closeAdded(); });
      added.addEventListener('mouseenter', function () { clearTimeout(addedTimer); });
      added.addEventListener('mouseleave', function () { addedTimer = setTimeout(closeAdded, 4000); });
      document.body.appendChild(added);
    }
    added.querySelector('[data-added-title]').textContent = info.title || '';
    added.querySelector('[data-added-meta]').textContent = [info.variant, info.qty ? info.qty + (info.qty === 1 ? ' case' : ' cases') : ''].filter(Boolean).join(' \u00b7 ');
    var im = added.querySelector('[data-added-img]'); im.innerHTML = '';
    if (info.img) { var i = document.createElement('img'); i.alt = ''; i.src = info.img + (info.img.indexOf('?') > -1 ? '&' : '?') + 'width=160'; im.appendChild(i); }
    im.hidden = !info.img;
    added.querySelector('[data-added-cart]').textContent = count ? 'View cart (' + count + ')' : 'View cart';
    added.classList.add('is-open');
    clearTimeout(addedTimer); addedTimer = setTimeout(closeAdded, 8000);
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAdded(); });
  function nativeAdd(form, info) {
    try { sessionStorage.setItem('mm_added', JSON.stringify(info)); } catch (err) {}
    var rt = form.querySelector('input[name="return_to"]');
    if (!rt) { rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; form.appendChild(rt); }
    rt.value = 'back';
    form.setAttribute('data-after-add', 'cart');
    HTMLFormElement.prototype.submit.call(form);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-after-add]') || form.getAttribute('data-after-add') === 'cart') return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-btn]'), err = form.querySelector('[data-add-error]');
    var label = btn ? btn.textContent : '';
    var fileIn = form.querySelector('input[type="file"]');
    var hasFile = !!(fileIn && fileIn.files && fileIn.files.length);
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    if (err) { err.hidden = true; err.textContent = ''; }
    if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
    function done() { if (btn) { btn.disabled = false; btn.textContent = label; } }
    fetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          done();
          if (err) { err.textContent = (res.j && (res.j.description || res.j.message)) || 'Could not add to cart. Please try again.'; err.hidden = false; }
          return;
        }
        var item = (res.j && res.j.items) ? res.j.items[0] : res.j;
        var info = { title: item.product_title, variant: item.variant_title, qty: qty, img: item.image || (item.featured_image && item.featured_image.url) || '' };
        if (hasFile) {
          var art = item.properties && (item.properties.Artwork || item.properties['_Artwork']);
          if (!(typeof art === 'string' && /^(https?:)?\/\//.test(art))) {
            /* The file didn't come through on the cart line: undo and use a normal post, which always uploads it. */
            fetch(rootUrl() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.key, quantity: Math.max(0, (item.quantity || qty) - qty) }) })
              .catch(function () {}).then(function () { nativeAdd(form, info); });
            return;
          }
        }
        done();
        if (btn) { btn.textContent = 'Added \u2713'; setTimeout(function () { btn.textContent = label; }, 2000); }
        refreshCartCount().then(function (c) { showAdded(info, c && c.item_count); });
      })
      .catch(function () { done(); nativeAdd(form, { title: '', qty: qty }); });
  });
  /* After a normal-post fallback lands back on the page, still show the popup */
  (function () {
    var raw = null; try { raw = sessionStorage.getItem('mm_added'); sessionStorage.removeItem('mm_added'); } catch (err) {}
    if (!raw || /\/cart\/?$/.test(location.pathname)) return;
    try { var info = JSON.parse(raw); refreshCartCount().then(function (c) { showAdded(info, c && c.item_count); }); } catch (err) {}
  })();

  /* Lightbox (single images, or a browsable group via data-zoom-group + data-zoom-caption) */
  var box, group = [], gi = 0;
  function ensureBox() {
    if (box) return box;
    box = document.createElement('div'); box.className = 'lightbox';
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Image viewer');
    box.innerHTML = '<button type="button" class="lightbox__close" aria-label="Close">\u00d7</button>' +
      '<button type="button" class="lightbox__nav lightbox__nav--prev" data-lb-prev aria-label="Previous photo" hidden>\u2039</button>' +
      '<img alt="Zoomed image">' +
      '<button type="button" class="lightbox__nav lightbox__nav--next" data-lb-next aria-label="Next photo" hidden>\u203a</button>' +
      '<p class="lightbox__cap" data-lb-cap hidden></p>';
    box.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-lb-prev]')) { step(-1); return; }
      if (ev.target.closest('[data-lb-next]')) { step(1); return; }
      if (ev.target === box || ev.target.closest('.lightbox__close')) closeBox();
    });
    var x0 = null;
    box.addEventListener('touchstart', function (ev) { x0 = ev.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (ev) { if (x0 === null) return; var dx = ev.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 45) step(dx < 0 ? 1 : -1); }, { passive: true });
    document.body.appendChild(box); return box;
  }
  function openBox(src, cap) {
    if (!src) return; var b = ensureBox();
    var img = b.querySelector('img'); img.src = src; img.alt = cap || 'Zoomed image';
    var c = b.querySelector('[data-lb-cap]'); c.textContent = cap || ''; c.hidden = !cap; b.classList.toggle('has-cap', !!cap);
    var many = group.length > 1;
    b.querySelector('[data-lb-prev]').hidden = !many; b.querySelector('[data-lb-next]').hidden = !many;
    b.classList.add('is-open'); document.body.classList.add('modal-open');
  }
  function showAt(i) { gi = (i + group.length) % group.length; var el = group[gi]; openBox(el.getAttribute('data-zoom-src'), el.getAttribute('data-zoom-caption')); }
  function step(d) { if (group.length > 1) showAt(gi + d); }
  function closeBox() { if (box) { box.classList.remove('is-open'); document.body.classList.remove('modal-open'); } group = []; }
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-zoom-src]');
    if (z) {
      var g = z.getAttribute('data-zoom-group');
      if (g) {
        group = Array.prototype.filter.call(document.querySelectorAll('[data-zoom-group="' + g + '"]'), function (el) { var it = el.closest('[data-gal-item]'); return !(it && it.hidden); });
        showAt(Math.max(0, group.indexOf(z)));
      } else { group = []; openBox(z.getAttribute('data-zoom-src'), z.getAttribute('data-zoom-caption')); }
      return;
    }
    var m = e.target.closest('[data-zoomable]'); if (m) { group = []; openBox(m.currentSrc || m.src); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (!box || !box.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeBox();
    else if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'ArrowRight') step(1);
  });

  /* Gallery filter chips */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-gal-filter]'); if (!chip) return;
    var root = chip.closest('[data-gallery]'); if (!root) return;
    var f = chip.getAttribute('data-gal-filter');
    root.querySelectorAll('[data-gal-filter]').forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
    root.querySelectorAll('[data-gal-item]').forEach(function (it) { it.hidden = !(f === 'all' || it.getAttribute('data-type') === f); });
  });

  /* Artwork uploader */
  function fmtSize(b) { if (b < 1024) return b + ' B'; if (b < 1048576) return (b / 1024).toFixed(0) + ' KB'; return (b / 1048576).toFixed(1) + ' MB'; }
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-artwork-input]'); if (!input) return;
    var zone = input.closest('.artwork'); if (!zone) return;
    var preview = zone.querySelector('[data-artwork-preview]');
    var file = input.files && input.files[0];
    if (!file) { if (preview) preview.classList.remove('is-shown'); return; }
    if (preview) {
      var thumb = preview.querySelector('img'); var name = preview.querySelector('.fname'); var size = preview.querySelector('.fsize');
      if (name) name.textContent = file.name;
      if (size) size.textContent = fmtSize(file.size);
      if (thumb) {
        if (file.type && file.type.indexOf('image/') === 0) { thumb.src = URL.createObjectURL(file); thumb.style.display = ''; }
        else { thumb.removeAttribute('src'); thumb.style.display = 'none'; }
      }
      preview.classList.add('is-shown');
    }
  });
  document.addEventListener('click', function (e) {
    var clr = e.target.closest('[data-artwork-clear]'); if (!clr) return;
    e.preventDefault();
    var zone = clr.closest('.artwork'); if (!zone) return;
    var input = zone.querySelector('[data-artwork-input]'); var preview = zone.querySelector('[data-artwork-preview]');
    if (input) input.value = '';
    if (preview) preview.classList.remove('is-shown');
  });
  ['dragover', 'dragenter'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { var dz = e.target.closest('.dropzone'); if (dz) { e.preventDefault(); dz.classList.add('is-drag'); } });
  });
  ['dragleave', 'drop'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { var dz = e.target.closest('.dropzone'); if (dz) dz.classList.remove('is-drag'); });
  });

  /* Wholesale account: resale certificate form + tax status */
  function certKey(id) { return 'mm_cert_submitted_' + id; }
  function readFlag(id) { try { return window.localStorage.getItem(certKey(id)); } catch (e) { return null; } }
  function writeFlag(id, v) { try { window.localStorage.setItem(certKey(id), v); } catch (e) {} }
  function today() {
    var d = new Date(); var m = d.getMonth() + 1; var day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }
  // "Already sent" = html.sample-sent / html.cert-sent (set in layout/theme.liquid from this device's memory,
  // the customer's tags or a tax-exempt account). CSS then hides the form and every prompt pointing at it.
  var ROOT = document.documentElement;
  function isSent(kind) { return ROOT.classList.contains(kind + '-sent'); }
  function intoView(el) {
    window.setTimeout(function () { try { el.scrollIntoView({ block: 'start' }); el.focus({ preventScroll: true }); } catch (err) {} }, 80);
  }
  // Successful submission: remember it on this device, lock the form, and bring the confirmation into view
  // (after a submit Shopify jumps to the form, which used to leave the message under the sticky header).
  document.querySelectorAll('[data-cert-success]').forEach(function (el) {
    var id = el.getAttribute('data-customer-id'); if (id) writeFlag(id, today());
    ROOT.classList.add('cert-sent'); intoView(el);
  });
  document.querySelectorAll('[data-cert-status]').forEach(function (el) {
    var id = el.getAttribute('data-customer-id'); if (!id || !(isSent('cert') || readFlag(id))) return;
    var todo = el.querySelector('[data-cert-todo]'); var rev = el.querySelector('[data-cert-review]');
    if (todo) todo.hidden = true; if (rev) rev.hidden = false;
    el.classList.add('tax-status--review');
  });
  // Date signed = the customer's local date at submission (page HTML may be cached).
  document.querySelectorAll('[data-cert-date]').forEach(function (el) { el.value = today(); });
  // These checks run in the capture phase and stop the event when something is missing:
  // Shopify's own form script (in the page head) otherwise submits the form before the theme can stop it.
  function blockSubmit(e) { e.preventDefault(); e.stopPropagation(); }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-cert-form]'); if (!f) return;
    var d = f.querySelector('[data-cert-date]'); if (d) d.value = today();
    var pn = f.querySelector('[data-printed-name]'); var sg = f.querySelector('[data-signature]');
    if (pn && sg && sg.value.trim() && pn.value.trim() && sg.value.trim().toLowerCase() !== pn.value.trim().toLowerCase()) {
      blockSubmit(e);
      sg.setCustomValidity('Type your signature exactly as your printed name.');
      sg.reportValidity();
    }
  }, true);
  document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('[data-signature]')) e.target.setCustomValidity(''); });

  /* Cart shipping estimator: same rates as checkout, for any visitor (Cart API) */
  function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function shipErr(j) {
    if (j && typeof j === 'object') {
      if (typeof j.error === 'string') return j.error;
      var msgs = [];
      Object.keys(j).forEach(function (k) { var v = j[k]; if (Array.isArray(v)) msgs.push((k === 'zip' ? 'ZIP' : k.charAt(0).toUpperCase() + k.slice(1)) + ' ' + v.join(', ')); });
      if (msgs.length) return msgs.join('. ') + '.';
    }
    return 'We couldn\u2019t get rates for that address. Check the ZIP and try again.';
  }
  function runEstimate(box) {
    if (!box || !window.fetch) return;
    var zipEl = box.querySelector('[data-ship-zip]'), provEl = box.querySelector('[data-ship-province]');
    var out = box.querySelector('[data-ship-out]'), btn = box.querySelector('[data-ship-go]');
    var zip = (zipEl.value || '').trim(), cur = box.getAttribute('data-currency') || 'USD';
    if (!/^\d{5}(-\d{4})?$/.test(zip)) { out.innerHTML = '<p class="ship-est__err">Enter a 5-digit ZIP code.</p>'; zipEl.focus(); return; }
    var q = 'shipping_address%5Bcountry%5D=' + encodeURIComponent('United States') + '&shipping_address%5Bprovince%5D=' + encodeURIComponent(provEl.value) + '&shipping_address%5Bzip%5D=' + encodeURIComponent(zip);
    var tries = 0;
    btn.disabled = true; out.innerHTML = '<p class="ship-est__wait">Getting rates\u2026</p>';
    function fail(msg) { out.innerHTML = '<p class="ship-est__err">' + esc(msg) + '</p>'; btn.disabled = false; }
    function show(rates) {
      if (!rates || !rates.length) { fail('No shipping rates came back for that address yet. Contact us for a delivery quote.'); return; }
      var sub = parseInt(box.getAttribute('data-subtotal'), 10) || 0;
      var list = rates.map(function (r) { return { name: r.name, cents: Math.round(parseFloat(r.price) * 100) || 0 }; })
        .sort(function (a, b) { return a.cents - b.cents; });
      var html = '<div class="ship-est__rates" role="radiogroup" aria-label="Shipping options">';
      list.forEach(function (r, i) {
        html += '<button type="button" class="ship-est__rate" role="radio" data-rate-cents="' + r.cents + '" aria-checked="' + (i === 0) + '">' +
          '<span class="ship-est__dot" aria-hidden="true"></span><span class="ship-est__name">' + esc(r.name) + '</span>' +
          '<strong>' + (r.cents === 0 ? 'Free' : money(r.cents, cur)) + '</strong></button>';
      });
      html += '</div><div class="ship-est__sum">' +
        '<div><span>Subtotal</span><span>' + money(sub, cur) + '</span></div>' +
        '<div><span>Shipping</span><span data-est-ship></span></div>' +
        '<div class="ship-est__total"><span>Estimated total</span><strong data-est-total></strong></div>' +
        '<p class="ship-est__taxnote">' + (box.hasAttribute('data-exempt') ? 'No sales tax &mdash; your account is tax-exempt.' : 'Plus sales tax, unless your account is approved as tax-exempt.') + '</p></div>';
      out.innerHTML = html; btn.disabled = false;
      updateEstimateTotal(box);
    }
    function poll() {
      tries++;
      fetch(rootUrl() + 'cart/async_shipping_rates.json?' + q, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { fail(shipErr(res.j)); return; }
          if (res.j && res.j.shipping_rates) { show(res.j.shipping_rates); return; }
          if (tries < 20) setTimeout(poll, 600); else fail('Rates are taking a while. Please try again in a moment.');
        })
        .catch(function () { fail('We couldn\u2019t get rates right now. Please try again in a moment.'); });
    }
    fetch(rootUrl() + 'cart/prepare_shipping_rates.json?' + q, { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function (r) { if (r.ok) { setTimeout(poll, 400); return null; } return r.json().then(function (j) { fail(shipErr(j)); }); })
      .catch(function () { fail('We couldn\u2019t get rates right now. Please try again in a moment.'); });
  }
  function updateEstimateTotal(box) {
    var sel = box.querySelector('.ship-est__rate[aria-checked="true"]'); if (!sel) return;
    var cur = box.getAttribute('data-currency') || 'USD';
    var sub = parseInt(box.getAttribute('data-subtotal'), 10) || 0, ship = parseInt(sel.getAttribute('data-rate-cents'), 10) || 0;
    var s = box.querySelector('[data-est-ship]'), t = box.querySelector('[data-est-total]');
    if (s) s.textContent = ship === 0 ? 'Free' : money(ship, cur);
    if (t) t.textContent = money(sub + ship, cur);
  }
  document.addEventListener('click', function (e) {
    var r = e.target.closest && e.target.closest('.ship-est__rate'); if (!r) return;
    e.preventDefault(); var box = r.closest('[data-ship-est]');
    box.querySelectorAll('.ship-est__rate').forEach(function (b) { b.setAttribute('aria-checked', String(b === r)); });
    updateEstimateTotal(box);
  });
  document.addEventListener('click', function (e) { var b = e.target.closest('[data-ship-go]'); if (b) { e.preventDefault(); runEstimate(b.closest('[data-ship-est]')); } });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-ship-zip]')) { e.preventDefault(); runEstimate(e.target.closest('[data-ship-est]')); }
  });

  /* Sample request: upload the logo to Cloudinary; its link goes into the emailed form */
  var MAX_LOGO = 10 * 1048576;
  function logoReset(box) {
    var urlEl = box.querySelector('[data-logo-url]'), prev = box.querySelector('[data-logo-preview]'), file = box.querySelector('[data-logo-file]');
    if (urlEl) urlEl.value = ''; if (file) file.value = ''; if (prev) prev.classList.remove('is-shown');
    box.removeAttribute('data-uploading'); box.removeAttribute('data-upload-failed');
  }
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-logo-file]'); if (!input) return;
    var box = input.closest('[data-logo-upload]'); if (!box) return;
    var file = input.files && input.files[0];
    var urlEl = box.querySelector('[data-logo-url]'), prev = box.querySelector('[data-logo-preview]'), status = box.querySelector('[data-logo-status]');
    urlEl.value = ''; box.removeAttribute('data-upload-failed');
    if (!file) { logoReset(box); return; }
    var name = prev.querySelector('.fname'), thumb = prev.querySelector('img');
    if (name) name.textContent = file.name;
    if (thumb) { if (file.type && file.type.indexOf('image/') === 0) { thumb.src = URL.createObjectURL(file); thumb.style.display = ''; } else { thumb.removeAttribute('src'); thumb.style.display = 'none'; } }
    prev.classList.add('is-shown');
    if (file.size > MAX_LOGO) { status.textContent = 'That file is over 10 MB. Please pick a smaller one.'; input.value = ''; return; }
    status.textContent = 'Uploading\u2026'; box.setAttribute('data-uploading', '1');
    var fd = new FormData(); fd.append('file', file); fd.append('upload_preset', box.getAttribute('data-preset'));
    fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(box.getAttribute('data-cloud')) + '/auto/upload', { method: 'POST', body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        box.removeAttribute('data-uploading');
        if (res.ok && res.j && res.j.secure_url) { urlEl.value = res.j.secure_url; status.textContent = fmtSize(file.size) + ' \u00b7 uploaded \u2713'; }
        else { box.setAttribute('data-upload-failed', '1'); urlEl.value = 'Upload failed (' + file.name + ') - ask the customer to email it'; status.textContent = 'Upload didn\u2019t work. You can still submit, and email us the logo after.'; }
      })
      .catch(function () {
        box.removeAttribute('data-uploading'); box.setAttribute('data-upload-failed', '1');
        urlEl.value = 'Upload failed (' + file.name + ') - ask the customer to email it';
        status.textContent = 'Upload didn\u2019t work. You can still submit, and email us the logo after.';
      });
  });
  document.addEventListener('click', function (e) {
    var clr = e.target.closest('[data-logo-clear]'); if (!clr) return;
    e.preventDefault(); var box = clr.closest('[data-logo-upload]'); if (box) logoReset(box);
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-sample-form]'); if (!f) return;
    var group = f.querySelector('[data-cup-group]');
    if (group && !group.querySelector('[data-cup-check]:checked')) {
      blockSubmit(e);
      var err = f.querySelector('[data-cup-error]'); if (err) err.hidden = false;
      group.classList.add('is-missing'); group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var box = f.querySelector('[data-logo-upload]'); if (!box) return;
    var status = box.querySelector('[data-logo-status]'), urlEl = box.querySelector('[data-logo-url]');
    if (box.hasAttribute('data-uploading')) { blockSubmit(e); alert('Your logo is still uploading. Give it a few seconds, then submit.'); return; }
    if (!urlEl.value) { blockSubmit(e); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); box.classList.add('is-missing'); alert('Please add your logo so we can make your sample.'); }
  }, true);
  document.addEventListener('change', function (e) {
    if (!(e.target.matches && e.target.matches('[data-cup-check]'))) return;
    var g = e.target.closest('[data-cup-group]'); if (!g) return;
    if (g.querySelector('[data-cup-check]:checked')) {
      g.classList.remove('is-missing');
      var err = g.parentNode.querySelector('[data-cup-error]'); if (err) err.hidden = true;
    }
  });
  /* Sample request received: remember it on this device, hide the form from now on, show the confirmation. */
  document.querySelectorAll('[data-sample-success]').forEach(function (el) {
    var id = el.getAttribute('data-customer-id'); if (id) { try { window.localStorage.setItem('mm_sample_submitted_' + id, today()); } catch (err) {} }
    ROOT.classList.add('sample-sent'); intoView(el);
  });
  // "Request another sample": bring the form back in place. (On the just-sent confirmation there is no form
  // in the page, so there the link reloads this page with #another, which layout/theme.liquid honors.)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-sample-again]'); if (!a) return;
    var form = document.getElementById('another'); if (!form) return;
    e.preventDefault(); ROOT.classList.remove('sample-sent');
    try { window.history.replaceState(null, '', '#another'); } catch (err) {}
    form.scrollIntoView({ block: 'start' });
    var first = form.querySelector('input:not([type="hidden"]), select, textarea'); if (first) { try { first.focus({ preventScroll: true }); } catch (err) {} }
  });
  // "Sent Oct 2" under the already-received panels, when this device remembers the date.
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  document.querySelectorAll('[data-sent-date]').forEach(function (el) {
    var box = el.closest('[data-customer-id]'); var id = box && box.getAttribute('data-customer-id'); var v = null;
    try { v = id && window.localStorage.getItem('mm_' + el.getAttribute('data-sent-date') + '_submitted_' + id); } catch (err) {}
    var p = v ? String(v).split('-') : []; if (p.length !== 3 || !(+p[1] >= 1 && +p[1] <= 12)) return;
    el.textContent = 'Sent ' + MONTHS[+p[1] - 1] + ' ' + (+p[2]); el.hidden = false;
  });

  /* Forms that email the store (sample request, tax form, contact, quote): show "Sending..." and ignore extra clicks.
     Extra clicks are stopped at the button, not at the form, so Shopify's spam check can still finish the send. */
  function sendingOff(f) {
    var b = f.querySelector('button.is-sending'); f.removeAttribute('data-sending');
    if (b) { b.classList.remove('is-sending'); b.removeAttribute('aria-disabled'); if (b.hasAttribute('data-label')) b.textContent = b.getAttribute('data-label'); }
  }
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches || !f.matches('form[action*="/contact"]')) return;
    if (e.defaultPrevented || f.getAttribute('data-sending')) return;
    var b = f.querySelector('button[type="submit"]'); if (!b) return;
    f.setAttribute('data-sending', '1');
    b.setAttribute('data-label', b.textContent); b.textContent = b.getAttribute('data-sending-label') || 'Sending\u2026';
    b.classList.add('is-sending'); b.setAttribute('aria-disabled', 'true');
    window.setTimeout(function () { sendingOff(f); }, 15000);
  }, true);
  document.addEventListener('click', function (e) {
    if (e.isTrusted && e.target.closest && e.target.closest('button.is-sending')) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) Array.prototype.forEach.call(document.querySelectorAll('form[data-sending]'), sendingOff);
  });
  document.querySelectorAll('[data-step-sample]').forEach(function (el) {
    var id = el.getAttribute('data-customer-id'); var v = null; try { v = id && window.localStorage.getItem('mm_sample_submitted_' + id); } catch (err) {}
    if (v || isSent('sample')) { el.classList.add('is-done'); el.classList.remove('is-current'); var n = el.querySelector('.acct-step__n'); if (n) n.textContent = '\u2713'; }
  });

  document.querySelectorAll('[data-step-cert]').forEach(function (el) {
    var id = el.getAttribute('data-customer-id'); if (!id || !(isSent('cert') || readFlag(id))) return;
    el.classList.add('is-done'); el.classList.remove('is-current');
    var n = el.querySelector('.acct-step__n'); if (n) n.textContent = '\u2713';
    var sub = el.querySelector('span:not(.acct-step__n)'); if (sub) sub.textContent = 'Submitted \u2014 we\u2019re reviewing it';
  });
  /* Scroll reveal */
  var rev = document.querySelectorAll('.reveal');
  if (rev.length) {
    if (reduce || !('IntersectionObserver' in window)) { rev.forEach(function (el) { el.classList.add('is-visible'); }); }
    else { var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-visible'); io.unobserve(x.target); } }); }, { threshold: .12, rootMargin: '0px 0px -8% 0px' }); rev.forEach(function (el) { io.observe(el); }); }
  }

  refreshCartCount();
})();
